import { useState, useEffect } from "react"
import { useUpdateExerciseMutation, useDeleteExerciseMutation } from "./exercisesApiSlice"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTrashCan, faDumbbell } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'



const EditExerciseForm = ({ exercise, exercisetypes, bodyparts }) => {

    const [updateExercise, {
        isSuccess,
        isError,
        error
    }] = useUpdateExerciseMutation()

    const [deleteExercise, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteExerciseMutation()

    const navigate = useNavigate()

    const [exercise_name, setExercisename] = useState(exercise.exercise_name)
    const [body_part, setBodypart] = useState(exercise.body_part)
    const [exercise_type, setExercisetype] = useState(exercise.exercise_type)
    const [exercise_details, setExercisedetails] = useState(exercise.exercise_details)
    const [video, setVideo] = useState(exercise.video)

    useEffect(() => {
        if (isSuccess) {
            setExercisename('')
            setBodypart('')
            setExercisetype('')
            setExercisedetails('')
            setVideo('')
            toast.success("Exercise was Updated");
            navigate('/dash/exercises')
        }

        if (isDelSuccess) {
            setExercisename('')
            setBodypart('')
            setExercisetype('')
            setExercisedetails('')
            setVideo('')
            toast.success("Exercise was Deleted");
            navigate('/dash/exercises')
        }

        if (isError) {
            toast.error(error?.data?.message);
        }

        if (isDelError) {
            toast.error(delerror?.data?.message);
        }


    }, [isSuccess, isDelSuccess, navigate, isError, isDelError, error, delerror])

    const onExercisenameChanged = e => setExercisename(e.target.value)
    const onBodypartChanged = e => setBodypart(e.target.value)
    const onExercisetypeChanged= e => setExercisetype(e.target.value)
    const onDetailsChanged= e => setExercisedetails(e.target.value)
    const onVideoChanged= e => setVideo(e.target.value)

    const optionsBP = bodyparts.map(bodypart => {
        return (
            <option key={bodypart.id} value={bodypart.id}>
                {bodypart.bodypart}
            </option >
        )
    })

    const optionsET = exercisetypes.map(exercisetype => {
        return (
            <option key={exercisetype.id} value={exercisetype.id}>
                {exercisetype.exercisetype}
            </option >
        )
    })

    let canSave
    canSave = [exercise_name.length, exercise_type.length, body_part.length, exercise_details.length].every(Boolean)


    const onSaveExerciseClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await updateExercise({ id: exercise.id, exercise_name, body_part, exercise_type, exercise_details, video })
        } else {
            toast.error('All Fields are Required');
        }        
    }

    const onDeleteExerciseClicked = async () => {
        await deleteExercise({ id: exercise.id })
    }

    const onExercisesClicked = async () => {
        navigate('/dash/exercises')
    }



    const content = (
        <section id="main_content">
            <header>
                <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faDumbbell} style={{fontSize:"30px", marginRight:"5px"}} />Edit Exercise</h1>
            </header>
            <main>
                <form onSubmit={e => e.preventDefault()}>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="exercise_name">
                                Exercise:
                            </label>
                            <input
                                className="form-control"
                                id="exercise_name"
                                name="exercise_name"
                                type="text"
                                autoComplete="off"
                                value={exercise_name}
                                onChange={onExercisenameChanged}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label" htmlFor="body_part">
                                Region:
                            </label>
                            <select
                                id="body_part"
                                name="body_part"
                                className="form-select"
                                value={body_part}
                                onChange={onBodypartChanged}
                            >
                                {optionsBP}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label" htmlFor="exercise_type">
                                Type:
                            </label>
                            <select
                                id="exercise_type"
                                name="exercise_type"
                                className="form-select"
                                value={exercise_type}
                                onChange={onExercisetypeChanged}
                            >
                                {optionsET}
                            </select>
                        </div>
                    </div>

                    <div className="row mb-3 mt-3">
                        <div className="col-md-12">
                            <label className="form-label" htmlFor="video">
                                Video:
                            </label>
                            <input
                                className="form-control"
                                id="video"
                                name="video"
                                type="text"
                                autoComplete="off"
                                value={video}
                                onChange={onVideoChanged}
                            />
                        </div>
                    </div>


                    <div className="row mb-3 mt-3">
                        <div className="col-md-12">
                            <label className="form-label" htmlFor="exercise_details">
                                Details:
                            </label>
                            <textarea
                                className="form-control"
                                id="exercise_details"
                                rows="7"
                                name="text"
                                value={exercise_details}
                                onChange={onDetailsChanged}
                            />
                        </div>
                    </div>

                    <div className="row mb-3 mt-5">
                        <div className="col-md-12 text-end">
                            <span
                                role="button"
                                className="p-2 text-success icon"
                                title="Save"
                                onClick={onSaveExerciseClicked}
                            >
                                Update Exercise
                                <FontAwesomeIcon icon={faSave}  className="fa-icon"/>
                            </span>
                            <span
                                role="button"
                                className="p-2 text-danger icon"
                                title="Delete"
                                onClick={onDeleteExerciseClicked}
                            >
                                Delete
                                <FontAwesomeIcon icon={faTrashCan}  className="fa-icon"/>
                            </span>
                            <span
                                role="button"
                                className="p-2 text-info icon"
                                title="Back to Exercises"
                                onClick={onExercisesClicked}
                            >
                                Back to Exercises
                                <FontAwesomeIcon icon={faDumbbell}  className="fa-icon"/>
                            </span>
                            
                        </div>
                    </div>
                </form>

            </main>
        </section>
    )

    return content
}
export default EditExerciseForm